import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import { themeStyle, themeStyleDark } from "../components/Components";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import { API_URL } from "../actions/auth";
import { alertMessage } from "../actions/auth";

import {
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  MenuItem,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import axios from "axios";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

const StudentRegistrationForm = () => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: "NAV_COLOR",
      payload: { navColor: "#000c66", navOpacity: 1 },
    });
  }, []);

  const [formData, setFormData] = useState({
    student: {
      firstName: "",
      middleName: "",
      lastName: "",
      aadharNo: "",
      dateOfBirth: "",
      gender: "",
      religion: "",
      casteIncomeCert: "",
      fatherCasteIncomeCert: "",
      community: "",
      bplFamily: false,
      bplCardNo: "",
      bankDetails: "",
      bhagyalakshmiNo: "",
      reasonForAge: "",
    },
    parent: {
      fatherName: "",
      fatherAadharNo: "",
      fatherProfession: "",
      fatherDesignation: "",
      fatherOrganization: "",
      motherName: "",
      motherAadharNo: "",
      address: "",
      contact: "",
      email: "",
      fax: "",
    },
    academic: {
      admissionFor: "",
      medium: "",
      motherTongue: "",
      previousSchoolName: "",
      previousSchoolMode: "",
      previousSchoolAddress: "",
      previousSchoolSyllabus: "",
      tcIssueDate: "",
    },
    specialDetails: {
      personality: "",
      healthIssues: "",
    },
    declaration: {
      accepted: false,
      date: "",
    },
  });

  const handleInputChange = (section, field, value) => {
    setFormData({
      ...formData,
      [section]: {
        ...formData[section],
        [field]: value,
      },
    });
  };

  function handleSubmit(e) {
    e.preventDefault();
    var body = {};
    body["name"] = formData.student.firstName + " " + formData.student.lastName;
    body["email"] = formData.parent.email;
    body["phone_number"] = formData.parent.contact;
    body["class"] = formData.academic.admissionFor;
    body["content"] = formData;
    body["form_id"] = makeid(10);
    console.log(API_URL + "/register");
    axios
      .post(API_URL + "/register", JSON.stringify(body))
      .then((res) => {
        console.log("REGISISI");
        dispatch(
          alertMessage(
            "SUCCESS",
            "SUCCESS",
            "Your request has been submitted. Our team will get back to you."
          )
        );
      })
      .catch((err) => {});
  }

  return (
    <div className="main">
      <Sidebar />
      <div className="overlay"></div>

      <div
        className="abouthero"
        style={{
          background:
            "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
            require("../img/asmb.jpg") +
            "')",
        }}
      >
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "30px",
            fontWeight: "bold",
            fontFamily: "Montserrat",
            color:
              state.auth.theme == "dark"
                ? themeStyleDark.primaryButtonTextColor
                : themeStyle.primaryButtonTextColor,
          }}
        >
          Admission Form
        </div>
      </div>
      <div
        style={{
          width: "90%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "10px",
        }}
      >
        <Box
          style={{
            marginTop: "100px",
            marginBottom: "200px",
          }}
          component="form"
          onSubmit={handleSubmit}
          p={state.auth.isMobile ? 0 : 3}
        >
          <Typography variant="h4" gutterBottom>
            Student Registration Form
          </Typography>

          <Typography variant="h6">Student Personal Details</Typography>
          <br />
          <Grid container spacing={5}>
            <Grid item xs={12} sm={4}>
              <TextField
                label="First Name"
                fullWidth
                value={formData.student.firstName}
                onChange={(e) =>
                  handleInputChange("student", "firstName", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Middle Name"
                fullWidth
                value={formData.student.middleName}
                onChange={(e) =>
                  handleInputChange("student", "middleName", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Last Name"
                fullWidth
                value={formData.student.lastName}
                onChange={(e) =>
                  handleInputChange("student", "lastName", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Aadhar Number"
                fullWidth
                value={formData.student.aadharNo}
                onChange={(e) =>
                  handleInputChange("student", "aadharNo", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Date of Birth"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.student.dateOfBirth}
                onChange={(e) =>
                  handleInputChange("student", "dateOfBirth", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Reason for Below age or Above age"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.student.reasonForAge}
                onChange={(e) =>
                  handleInputChange("student", "reasonForAge", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Gender"
                select
                fullWidth
                value={formData.student.gender}
                onChange={(e) =>
                  handleInputChange("student", "gender", e.target.value)
                }
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Religion"
                select
                fullWidth
                value={formData.student.religion}
                onChange={(e) =>
                  handleInputChange("student", "religion", e.target.value)
                }
              >
                <MenuItem value="Hindu">Hindu</MenuItem>
                <MenuItem value="Muslim">Muslim</MenuItem>
                <MenuItem value="Christian">Christian</MenuItem>
                <MenuItem value="Sikh">Sikh</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Community"
                fullWidth
                select
                value={formData.student.community}
                onChange={(e) =>
                  handleInputChange("student", "community", e.target.value)
                }
              >
                <MenuItem value="General">General</MenuItem>
                <MenuItem value="OBC">OBC</MenuItem>
                <MenuItem value="SC">SC</MenuItem>
                <MenuItem value="ST">ST</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Caste Income Certificate"
                fullWidth
                value={formData.student.casteIncomeCert}
                onChange={(e) =>
                  handleInputChange(
                    "student",
                    "casteIncomeCert",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Father Caste Income Certificate"
                fullWidth
                value={formData.student.fatherCasteIncomeCert}
                onChange={(e) =>
                  handleInputChange(
                    "student",
                    "fatherCasteIncomeCert",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.student.bplFamily}
                    onChange={(e) =>
                      handleInputChange(
                        "student",
                        "bplFamily",
                        e.target.checked
                      )
                    }
                  />
                }
                label="Belongs to BPL Family"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="BPL Card No"
                fullWidth
                value={formData.student.bplCardNo}
                onChange={(e) =>
                  handleInputChange("student", "bplCardNo", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Bhagyalakshmi Bond No"
                fullWidth
                value={formData.student.bhagyalakshmiNo}
                onChange={(e) =>
                  handleInputChange(
                    "student",
                    "bhagyalakshmiNo",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Student Bank Account No."
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={formData.student.bankDetails}
                onChange={(e) =>
                  handleInputChange("student", "bankDetails", e.target.value)
                }
              />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Parent Details
          </Typography>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Father's Name"
                fullWidth
                value={formData.parent.fatherName}
                onChange={(e) =>
                  handleInputChange("parent", "fatherName", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mothers's Name"
                fullWidth
                value={formData.parent.motherName}
                onChange={(e) =>
                  handleInputChange("parent", "motherName", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Father's Aadhar No"
                fullWidth
                value={formData.parent.fatherAadharNo}
                onChange={(e) =>
                  handleInputChange("parent", "fatherAadharNo", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                label="Mother's Aadhar No"
                fullWidth
                value={formData.parent.motherAadharNo}
                onChange={(e) =>
                  handleInputChange("parent", "motherAadharNo", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                label="Address"
                fullWidth
                multiline
                rows={3}
                value={formData.parent.address}
                onChange={(e) =>
                  handleInputChange("parent", "address", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Contact"
                fullWidth
                value={formData.parent.contact}
                onChange={(e) =>
                  handleInputChange("parent", "contact", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Email"
                type="email"
                fullWidth
                value={formData.parent.email}
                onChange={(e) =>
                  handleInputChange("parent", "email", e.target.value)
                }
              />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Academic Details
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Admission For"
                select
                fullWidth
                value={formData.academic.admissionFor}
                onChange={(e) =>
                  handleInputChange("academic", "admissionFor", e.target.value)
                }
              >
                <MenuItem value="LKG">LKG</MenuItem>
                <MenuItem value="UKG">UKG</MenuItem>
                <MenuItem value="Class 1">Class 1</MenuItem>
                <MenuItem value="Class 2">Class 2</MenuItem>
                <MenuItem value="Class 3">Class 3</MenuItem>
                <MenuItem value="Class 4">Class 4</MenuItem>
                <MenuItem value="Class 5">Class 5</MenuItem>
                <MenuItem value="Class 6">Class 6</MenuItem>
                <MenuItem value="Class 7">Class 7</MenuItem>
                <MenuItem value="Class 8">Class 8</MenuItem>
                <MenuItem value="Class 9">Class 9</MenuItem>
                <MenuItem value="Class 10">Class 10</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Medium"
                select
                fullWidth
                value={formData.academic.medium}
                onChange={(e) =>
                  handleInputChange("academic", "medium", e.target.value)
                }
              >
                <MenuItem value="Kannada">Kannada</MenuItem>
                <MenuItem value="English">English</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mother Tongue"
                select
                fullWidth
                value={formData.academic.motherTongue}
                onChange={(e) =>
                  handleInputChange("academic", "motherTongue", e.target.value)
                }
              >
                <MenuItem value="Kannada">Kannada</MenuItem>
                <MenuItem value="Hindi">Hindi</MenuItem>
                <MenuItem value="Telugu">Telugu</MenuItem>
                <MenuItem value="Tamil">Tamil</MenuItem>
                <MenuItem value="Malayalam">Malayalam</MenuItem>
                <MenuItem value="Marathi">Marathi</MenuItem>
                <MenuItem value="Gujarati">Gujarati</MenuItem>
                <MenuItem value="Bengali">Bengali</MenuItem>
                <MenuItem value="Punjabi">Punjabi</MenuItem>
                <MenuItem value="Odia">Odia</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Name of Previous School"
                fullWidth
                value={formData.parent.previousSchoolName}
                onChange={(e) =>
                  handleInputChange(
                    "parent",
                    "previousSchoolName",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Mode of Previous School"
                select
                fullWidth
                value={formData.academic.previousSchoolMode}
                onChange={(e) =>
                  handleInputChange(
                    "academic",
                    "previousSchoolMode",
                    e.target.value
                  )
                }
              >
                <MenuItem value="Government">Government</MenuItem>
                <MenuItem value="Private">Private</MenuItem>
                <MenuItem value="Aided">Aided</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Syllabus of Previous School"
                select
                fullWidth
                value={formData.academic.previousSchoolSyllabus}
                onChange={(e) =>
                  handleInputChange(
                    "academic",
                    "previousSchoolSyllabus",
                    e.target.value
                  )
                }
              >
                <MenuItem value="Government">ICSE</MenuItem>
                <MenuItem value="Private">CBSE</MenuItem>
                <MenuItem value="Aided">State Board</MenuItem>
                <MenuItem value="Aided">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="TC Issue Date"
                fullWidth
                value={formData.academic.tcIssueDate}
                onChange={(e) =>
                  handleInputChange("academic", "tcIssueDate", e.target.value)
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Previous School Address"
                fullWidth
                multiline
                rows={3}
                value={formData.parent.previousSchoolAddress}
                onChange={(e) =>
                  handleInputChange(
                    "parent",
                    "previousSchoolAddress",
                    e.target.value
                  )
                }
              />
            </Grid>
          </Grid>
          <Typography variant="h6" sx={{ mt: 4 }}>
            Special Details
          </Typography>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Personality of the student"
                fullWidth
                value={formData.specialDetails.personality}
                onChange={(e) =>
                  handleInputChange(
                    "specialDetails",
                    "personality",
                    e.target.value
                  )
                }
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                label="Special Health Issues"
                fullWidth
                value={formData.specialDetails.healthIssues}
                onChange={(e) =>
                  handleInputChange(
                    "specialDetails",
                    "healthIssues",
                    e.target.value
                  )
                }
              />
            </Grid>
          </Grid>

          <Typography variant="h6" sx={{ mt: 4 }}>
            Declaration
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={formData.declaration.accepted}
                onChange={(e) =>
                  handleInputChange("declaration", "accepted", e.target.checked)
                }
              />
            }
            label="I confirm that the information provided is correct."
          />

          <Box mt={3}>
            <Button type="submit" variant="contained" color="primary">
              Submit
            </Button>
          </Box>
        </Box>
      </div>
    </div>
  );
};

export default StudentRegistrationForm;
